import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'UnattendedProcess/GetUnattendedProcessViews', method: 'GET', body: null, token: token })
}
